import PurchaseTrainingConfirmationModal from './PurchaseTrainingConfirmationModal.vue';

export default PurchaseTrainingConfirmationModal;
